import script from "./MainGroup.vue?vue&type=script&setup=true&lang=js"
export * from "./MainGroup.vue?vue&type=script&setup=true&lang=js"

import "./MainGroup.vue?vue&type=style&index=0&id=ef8f944a&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ef8f944a"]])

export default __exports__